import React, { useState } from "react";
import OptionsAdmin from "./options/OptionsAdmin";
import MyAccount from "./account/MyAccount";
import Location from "./location/Location";
import Inventory from "./inventory/Inventory";
import AdminPanel from "./chat/AdminPanel";
import SellersAnalytics from "./selleranalytics/SellersAnalytics";
import ControlTower from "./controltower/ControlTower";
import AdminPrintDeliveries from "./print/AdminPrintDeliveries";
import AdminStatistics from "./statistics/AdminStatistics";
import ReferralDashboard from "./referral/ReferralDashboard";
import Entrega from "../user/entrega/Entrega";
import MasivoWizard from "../user/masivo/MasivoWizard";
import Integrations from "../shared/integrations/Integrations";

function MainAdmin({ user_id, username, onLogout, email, phone_number, onUpdateUser }) {
    const [activeComponent, setActiveComponent] = useState('OptionsAdmin');
    const [deliverySeller, setDeliverySeller] = useState(null);
    
    

    const handleBackClick = () => {
        setActiveComponent('MapAdmin');
         
    };
    
    const handleMenuClick = () => {
        setActiveComponent('OptionsAdmin');
    };

    const handleOptionClick = (option) => {
        if (option === 'back') {
            setActiveComponent(activeComponent === 'MapAdmin' ? 'admin' : 'MapAdmin');
        } else if (option === 'MapSelectionAdmin') {
            setActiveComponent('MapSelectionAdmin');
        } else if (option === 'OrderListAdmin') {
            setActiveComponent('OrderListAdmin')
        } else if (option === 'DeliveryListAdmin') {
            setActiveComponent('DeliveryListAdmin')
        } else if (option === 'OptionsAdmin') {
            setActiveComponent('OptionsAdmin')
        } else if (option === 'admin') {
            setActiveComponent('admin')
        } else if (option === 'SearchGlobal') {
            setActiveComponent('SearchGlobal')
        } else if (option === 'ResumenAdmin') {
            setActiveComponent('ResumenAdmin')
        }

        
        
        else {
            setActiveComponent('MyAccountAdmin')
            // Handle other options
            
        }
    };

    return (
        <div className="container-fluid p-0">
            {activeComponent === 'OptionsAdmin' &&  <OptionsAdmin username={username} onOptionClick={handleOptionClick} onBackClick={handleBackClick} onLogout={onLogout} setActiveComponent={setActiveComponent}/> }
            {activeComponent === 'AccountAdmin' && <MyAccount onUpdateUser={onUpdateUser} userId={user_id} username={username} phoneNumber={phone_number} email={email} onLogout={onLogout} setActiveComponent={setActiveComponent} />}
            {activeComponent === 'Inventory' && <Inventory userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'Chat' && <AdminPanel setActiveComponent={setActiveComponent} userId={user_id} />}
            {activeComponent === 'MissingLocations' && <Location setActiveComponent={setActiveComponent} userId={user_id}/> }  
            {activeComponent === 'Performance' && (
                <SellersAnalytics
                    userId={user_id}
                    setActiveComponent={setActiveComponent}
                    onCreateEntrega={(seller) => {
                        setDeliverySeller(seller);
                        setActiveComponent('ProviderEntrega');
                    }}
                    onCreateBulkEntrega={(seller) => {
                        setDeliverySeller(seller);
                        setActiveComponent('ProviderMasivoWizard');
                    }}
                />
            )}
            {activeComponent === 'ProviderEntrega' && deliverySeller && (
                <Entrega
                    userId={deliverySeller.id}
                    setActiveComponent={setActiveComponent}
                    returnComponent="Performance"
                    title={`Entrega para ${deliverySeller.username || `Usuario ${deliverySeller.id}`}`}
                    successPrimaryLabel="Volver a vendedores"
                />
            )}
            {activeComponent === 'ProviderMasivoWizard' && deliverySeller && (
                <MasivoWizard
                    userId={deliverySeller.id}
                    setActiveComponent={setActiveComponent}
                    returnComponent="Performance"
                    controlTowerComponent="ControlTower"
                    title={`Carga masiva para ${deliverySeller.username || `Usuario ${deliverySeller.id}`}`}
                    description="Sube un archivo Excel para crear entregas a este vendedor"
                    successPrimaryLabel="Volver a vendedores"
                />
            )}
            {activeComponent === 'ControlTower' && <ControlTower userId={user_id} setActiveComponent={setActiveComponent} /> }  
            {activeComponent === 'PrintDeliveries' && <AdminPrintDeliveries userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'AnalyticsProvider' && <AdminStatistics userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'Referrers' && <ReferralDashboard userId={user_id} setActiveComponent={setActiveComponent}/>}
            {activeComponent === 'Integrations' && <Integrations userId={user_id} setActiveComponent={setActiveComponent} returnComponent="OptionsAdmin" />}
        </div>
    );
}

export default MainAdmin;
